import { Controller } from '@hotwired/stimulus';
import Collapse from 'bootstrap/js/dist/collapse';

export default class extends Controller {
    static targets = [
        'toggle',
        'content'
    ];

    toggle(event) {
        event.preventDefault();

        const content = this.contentTarget;
        const bsCollapse = Collapse.getOrCreateInstance(content, { toggle: false });
        bsCollapse.toggle();

        const anchor = this.toggleTarget;
        const isExpanded = anchor.getAttribute('aria-expanded') === 'true';

        anchor.setAttribute('aria-expanded', !isExpanded);
        if (isExpanded) {
            anchor.classList.add('collapsed');
        } else {
            anchor.classList.remove('collapsed');
        }
    }
}
